// ============================================================
// ANSICHTSSACHE-AGENT – Anmelden mit Passkey
// ============================================================
// Zwei Schritte, zwei Aktionen: erst holt der Browser die
// Aufgabe, dann schickt er die Unterschrift des Geraets zurueck.
// Dazwischen liegt der Griff ins Betriebssystem (Fingerabdruck,
// Gesicht, PIN), und der gehoert dem Browser, nicht uns.
//
// Die ANMELDUNG selbst laeuft ueber denselben Weg wie die mit
// Kennwort — `signIn` mit dem Provider `passkey`. Damit ist die
// Sitzung, die dabei entsteht, in jeder Hinsicht dieselbe:
// gleiche Rolle, gleiche Gueltigkeit, gleicher Callback, der den
// Nutzer bei jedem Aufruf frisch laedt.
// ============================================================

"use server";

import { redirect } from "next/navigation";
import { zielNachAnmeldung } from "@/lib/auth/nach-anmeldung";
import { istWeiterleitung } from "@/lib/weiterleitung";
import { signIn } from "@/lib/auth";
import { anmeldeAufgabe } from "@/lib/auth/webauthn";

/** Schritt eins: die Aufgabe, die das Geraet unterschreiben soll. */
export async function passkeyAufgabe() {
  return anmeldeAufgabe();
}

/**
 * Schritt zwei: die Unterschrift pruefen und anmelden.
 *
 * Die Fehlermeldung nennt keinen Grund. Ob es den Passkey nicht
 * gibt, ob das Konto gesperrt ist oder ob die Aufgabe abgelaufen
 * war, geht den Absender nichts an — jede Unterscheidung waere
 * eine Auskunft darueber, welche Konten es gibt.
 */
export async function passkeyAnmelden(antwort: string): Promise<{ error: string } | undefined> {
  try {
    await signIn("passkey", { antwort, redirect: false });
  } catch (error) {
    // Eine Weiterleitung ist kein Fehler (siehe `actions.ts`).
    if (istWeiterleitung(error)) throw error;
    return { error: "Dieser Passkey wurde nicht erkannt." };
  }

  // Ausserhalb des `try`: `redirect` arbeitet, indem es wirft.
  // Ein Kunde landet von hier aus im Portal — das entscheidet
  // das Layout, nicht diese Stelle.
  // Kam jemand vom Stempelchip an der Tuer, geht es dorthin zurueck.
  redirect(await zielNachAnmeldung("/dashboard"));
}
